import { render, staticRenderFns } from "./LevelBtn.vue?vue&type=template&id=4fcc83dc&"
import script from "./LevelBtn.vue?vue&type=script&lang=js&"
export * from "./LevelBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports